import { BuilderEstimatorSteps } from "@/enums/BuilderEstimatorSteps";

export const BUILDER_ESTIMATOR_STEPS_MAP = {
  [BuilderEstimatorSteps.LAND_DETAILS]: "Land Details",
  [BuilderEstimatorSteps.VIEW_DESIGN]: "House Designs",
  [BuilderEstimatorSteps.SELECT_DESIGN]: "Select Design",
  [BuilderEstimatorSteps.SELECT_FACADE]: "Select Facade",
  [BuilderEstimatorSteps.SELECT_INCLUSIONS]: "Inclusions",
  [BuilderEstimatorSteps.OPTIONAL_UPGRADES]: "Promotions",
  [BuilderEstimatorSteps.SELECT_EXTERNAL_COLOURS]: "External Colours",
  [BuilderEstimatorSteps.SELECT_INTERNAL_COLOURS]: "Internal Colours",
  [BuilderEstimatorSteps.SUMMARY]: "Summary",
};
